import React, { PureComponent } from 'react'
import styled from 'styled-components'
import Leaderboard, { ILeaderboardSkin } from '../leaderboard/Leaderboard'
import { IMountainPlayerData } from '../../helpers/data/mountainPlayer'

import AudioElement from '../../components/audio/AudioElement'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	margin: auto;
	max-width: 1024px;
	max-height: 768px;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
`

const GameContainer = styled.div`
	max-width: 1024px;
	height: 100%;
	display: block;
`

const LeaderboardContainer = styled.div`
	height: 100%;
	width: 100%;
	background-color: rgba(127, 127, 127, 1);
	display: inline-block;
	vertical-align: top;
`

interface IGameProps {
	players: IMountainPlayerData[]
	skin: ISkin
	totalActivities: number
}

export interface ISkin {
	leaderboard: ILeaderboardSkin
}

class Game extends PureComponent<IGameProps> {
	private elapsedTime = 0

	state = {
		countdownComplete: false,
	}

	render() {
		const croppingWidth = 'calc(100% - 270px)'

		return (
			<Wrapper>
				<GameContainer>
					<LeaderboardContainer style={{ width: '100%' }}>
						<Leaderboard
							totalActivities={this.props.totalActivities}
							currentActivity={this.props.totalActivities}
							croppingWidth={croppingWidth}
							players={this.props.players}
							skin={this.props.skin.leaderboard}
							shouldShowCorrectAnswers={false}
						/>
					</LeaderboardContainer>
				</GameContainer>
				<AudioElement src={'audios/gameplay.mp3'} />
			</Wrapper>
		)
	}
}

export default Game
